import { render } from "./ProgCreatorEdit.vue?vue&type=template&id=b0bab1a6"
import script from "./ProgCreatorEdit.vue?vue&type=script&lang=js"
export * from "./ProgCreatorEdit.vue?vue&type=script&lang=js"

import "./ProgCreatorEdit.vue?vue&type=style&index=0&id=b0bab1a6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__